/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect,useMemo, useState, useCallback } from 'react';
import { APIEndpoint } from "../../../utils/axios";
import { DataGrid,Modal } from "../../../common";
import searchIcon from '../../../assets/icons/search.svg';
import editIcon2 from "../../../assets/edit2.svg"
import { Input } from "../../../common/Input";
import { useTranslation } from 'react-i18next';
import usePermissions from '../../../utils/userPermissions';
import CustomSelect from '../../../common/CustomSelect';

//   const filterData = {
//     action: 4,
//     collection: '',
//     filterOperation: 'or',
//     filters:[],
//     limit: 50,
//     page: 1,
//     searchParam: ''
//   };
  


const CreateFormFields = [
  { label: 'Currency Code', attribute: 'code', type: 'text', required: true },
  { label: 'Currency Name', attribute: 'name', type: 'text', required: true },
  { label: 'Rounding Factor', attribute: 'roundingFactor', type: 'number', required: true },
  { label: 'Base Currency', attribute: 'isBaseCurrency', type: 'checkbox', required: false },
  { label: 'Active', attribute: 'isActive', type: 'checkbox', required: false },
];


export const CurrencyMasterPage = () => {
  const { t,ready } = useTranslation();
  const [state, setState] = useState({
  currencies: { code: [], name: [] },
  cashDrawerList: null,
  data: null,
  showCreateDialog: false,
  showEditDialog: false,
  selectedDrawer: null,
  modalFormStatusObj: { text: '' }
});
const [cashDrawer, setCashDrawer] = useState('');
const [location, setLocation] = useState('');
const [searchKey, setSearchKey] = useState('');
const [resetDataSource, setResetDataSource] = useState(false);
const [currencyMaster, setCurrencyMaster] = useState([]);
const [isDropDownOpen,setIsDropdownOpen]=useState(false);
const [ModalContHeight,setModalContHeight]=useState({marginBottom:'auto'})
const isInitialLoad = React.useRef(true);
const isFetchingRef = React.useRef(false);
  const { hasPermission: createCurrencyMaster } = usePermissions('create', "common.master.currency");
  const { hasPermission: editCurrencyMaster } = usePermissions('edit', "common.master.currency");
  const { hasPermission: viewCurrencyMaster } = usePermissions('view', "common.master.currency");


const Columns = useMemo(() => ([
  { field: 'code', headerName: 'Currency Code', flex: 1 },
  { field: 'name', headerName: 'Currency Name', flex: 1 },
  {
  field: 'isBaseCurrency',
  headerName: 'Base Currency',
  valueGetter: p => {
    if (!p.data || p.data.isBaseCurrency === undefined) return "";
    return p.data.isBaseCurrency === true ? "Yes" : "No";
  }
},
{ field: 'roundingFactor', headerName: 'Rounding Factor' },
{
  field: 'isActive',
  headerName: 'Status',
  valueGetter: p => {
    if (!p.data || p.data.isActive === undefined) return "";
    return p.data.isActive === true ? "Active" : "Inactive";
  }
}
]), []);
  React.useEffect(() => {
    if(isDropDownOpen){
      setModalContHeight({marginBottom:'10rem'})
    }else{
      setModalContHeight({marginBottom:'auto'})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isDropDownOpen]);

useEffect(() => {
  if (isInitialLoad.current) {
    isInitialLoad.current = false;
    return;
  }

  setResetDataSource(prev => !prev);
}, [cashDrawer, location]);

useEffect(() => {
  if (!ready) return;

  fetchCurrenciesList();
}, [ready]);


const sectorTitle=()=>{
  const {name,code}=state.selected;

  if(state && state.showEditDialog && code?.length>0){          
return(<div className='flexRow justifyContentCenter'>
  <div className='flexRow'> 
    <div className='flexRow'>Edit Currency - <div className='instance-member-name'>{name} ({code})</div></div>
  </div>
</div>)
  }
  else{
    return(<></>)
  }

}

  const fetchCurrenciesList = async () => {
    if(currencyMaster.length) return;
    try {
          const resActCurrency = await APIEndpoint.get("currencies");

if (resActCurrency && resActCurrency?.items?.length) {
  const activeCurrencyCodes = resActCurrency.items
    .filter(c => c.isActive)
       .map((c, index) => ({
      key: index + 1,
      label: c.name,  
      value: c.code  
    }));

  setCurrencyMaster(activeCurrencyCodes);
}

    } catch (error) {

    }

  }

const fetchCashDrawers = useCallback(
  async (page = 1, perPage = 50) => {
    if(!viewCurrencyMaster)return;
    if(isFetchingRef.current) return;
    isFetchingRef.current  = true;
  const params = new URLSearchParams({search: searchKey || location || cashDrawer || ""});
    try {
      const res = await APIEndpoint.get(`currencies?${params.toString()}`);
        setState(prev => ({
    ...prev,
    currencies:{code:res.items?.map((resC,index)=>({key:index,label:resC.code,value:resC.code})),name:res.items?.map((resC,index)=>({key:index,label:resC.name,value:resC.name}))},
  }));
      return res;
    } catch (error) {
      console.error('Failed to fetch list:', error);
    }
    finally{
      isFetchingRef.current  = false;
    }
  },
  [searchKey, viewCurrencyMaster, location, cashDrawer]
);


  const onSearch = (e) => {
    setSearchKey(e.target.value);
    setResetDataSource(prev => !prev);
  };

  const onAction = async (e,action, rowData) =>{
if (action?.value === 'EditItem') {
  setState(prev => ({
    ...prev,
    formValues: rowData,
    selected:{code:rowData.code??"",name:rowData.name??""},
    showEditDialog: true
  }));
}

  };


const handleOnchangeCashDrawers = (e) => {

  const { name, value,type,checked } = e.target;
  setState(prev => {
    const updated = {
      ...prev.formValues,
      [name]: type === 'checkbox' ? checked : value
    };
    return {
      ...prev,
      modalFormStatusObj: { text: "" },
      formValues: updated
    };
  });
};


const enableButtons = (submitBtnObj, cancelButtonObj) => {
  submitBtnObj?.removeAttribute('disabled');
  if(cancelButtonObj){
  cancelButtonObj?.removeAttribute('disabled');
  }
};

const handleDrawerUpdate = async () => {
 const submitBtnObj = document.getElementsByClassName('done-button')[0];
  submitBtnObj?.setAttribute('disabled', 'true');
  if (state?.formValues) {

    const requiredFields = CreateFormFields.filter(f => f.required).map(f => f.attribute);

    const isValid = state.formValues && requiredFields.every(key => state.formValues?.[key]);

    if (!isValid) {
      setState(prev => ({
        ...prev,
        modalFormStatusObj: { error: "Please fill all the required fields" }
      }));
      enableButtons(submitBtnObj,null);
      return;
    }

    const {
        id,
      code,
      name,
      roundingFactor,
      isBaseCurrency,isActive
    } = state.formValues;

    const body = {
     ...(!id ?{code:code}:{}),
      name,
      roundingFactor: Number(roundingFactor),
      isBaseCurrency:isBaseCurrency ?? false,
      isActive: isActive ?? false
    };

    try {
      const res =!id ? await APIEndpoint.post('currencies',body) : await APIEndpoint.put(`currencies/${code}`,body);
      if (res?.message) {
        setState(prev => ({
          ...prev,
          modalFormStatusObj: { text: res.message }
        }));
      }

      setTimeout(() => {
        setState(prev => ({
          ...prev,
           ...(!id ? {showCreateDialog: false} : {showEditDialog: false}),
          formValues: {},
          modalFormStatusObj: { text: '' }
        }));
         enableButtons(submitBtnObj,null);
      }, 2000);

    } catch (error) {
      const errorMessage =
        error?.message
          ? JSON.parse(error.message)?.data?.message
          : 'Failed to create new drawer';

      setState(prev => ({
        ...prev,
        modalFormStatusObj: { error: errorMessage }
      }));
         enableButtons(submitBtnObj,null);
    }
    setResetDataSource(prev => !prev);
    return;
  

  
};
}


  return (
    <div className="flexCol width100 ag-theme-alpine-dark cash-reg">
    
          <div className='flexCol full-flex'>
            <div className='flexRow alignItemsCenter justifyContentSpaceBetween margBottom6'>
              <div className='flexRow alignItemsCenter'>

                <div className='margLeft6'>
                <CustomSelect
                  options={state.currencies.code}
                  placeHolder="Search Currency Code"
                 onChange={(e) => {
                const drawerId = e?.value || "";
                setCashDrawer(drawerId);
              }}
                />
                </div>
                  <div className='margLeft6'>
                <CustomSelect
                  options={state.currencies.name}
                  placeHolder="Search Currency Name"
                  menuPortalTarget={document?.body}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 })
                  }}
                  onChange={(e) => {
                    setLocation(e?.value|| "");
                  }}
                />
                </div>
                   <div className="flexRow justifyContentCenter alignItemsCenter width100 content-tabs">
                     <div className="margLeft margBot10 margTop8 underline">
                       <span><img className="icon-size" alt={t('filters.searchText')} src={searchIcon} /></span>
                       <span>
                         <input
                           className="search"
                           onChange={onSearch}
                           type="search"
                           placeholder={t('filters.searchText')}
                           value={searchKey}
                         />
                       </span>
                     </div>
                   </div>
              </div>
               <div className='flexRow justifyContentFlexEnd'>
                  {createCurrencyMaster ? <button className='add-item-button'
                  onClick={() => {
                    setState((_) => ({ ..._, showCreateDialog: true }))
                  }}>
                  {t('pages.cashRegisterContent.cashDrawer.addCurrency')}
                </button>:<></>}

              </div>
      
            </div>

              <DataGrid
                columnResize
                showDefaultFilters={false}
                enableGridSearch={false}
                className='full-flex'
                columns={Columns}
                initialPageLimit={500}
                getRows={fetchCashDrawers}          
                rowSelection="multiple"
                actions={editCurrencyMaster ? [{ title: 'Actions', detail: [{src: editIcon2,value:"EditItem",title:'Edit'}]}]: []}
                onAction={onAction}
                resetDataSource={resetDataSource}
              />

          </div>
      

{state.showCreateDialog  && (
  <Modal
    title={t('pages.cashRegisterContent.cashDrawer.newCurrencyTitle')}
    buttonLabel="Create"
    modalFormStatusObj={state.modalFormStatusObj}
    onSubmit={handleDrawerUpdate}
    customContentHeight={ModalContHeight}
    setIsDropdownOpen={setIsDropdownOpen}
    onChange={handleOnchangeCashDrawers}
    onClose={() =>{
      setState(prev => ({
        ...prev,
        showCreateDialog: false,
        formValues:{},
        modalFormStatusObj: { text: '' }
      }))
    }
    }
  >
{CreateFormFields.map(field => {
  return (
    <Input
      key={field.attribute}
      {...field}
      name={field.attribute}
      value={state.formValues?.[field.attribute]}
      onChange={handleOnchangeCashDrawers}
   
    />
  );
})}

  </Modal>
)}

{state.showEditDialog && (
  <Modal
    TitleComponent={sectorTitle}
    buttonLabel="Save"
    modalFormStatusObj={state.modalFormStatusObj}
    onSubmit={handleDrawerUpdate}
    onClose={() => {
      setState(prev => ({ ...prev, showEditDialog: false, formValues: {}, selected: {} , modalFormStatusObj: { text: '' } }));
    }}
  >
 
{CreateFormFields.map(field => {
    if (field.attribute === 'code') return null;
    const isCheckbox = field.attribute === 'isBaseCurrency' || field.attribute === 'isActive'
  return (
    <Input
      key={field.attribute}
      {...field}
      name={field.attribute}
      value={state.formValues?.[field.attribute]}
         {...(!isCheckbox && {
        value: state.formValues?.[field.attribute]
      })}

      {...(isCheckbox && {
        checked: !!state.formValues?.[field.attribute]
      })}
      onChange={handleOnchangeCashDrawers}
   
    />
  );
})}

  </Modal>
)}





    {
    !ready && <div className='overlay_hide sub'></div>
    }
    </div>
  )
}
